import apiService from "../../api/api.service";
import { GetPersonalizedProductsResponse } from "./personalizedProducts.types";

export const fetchPersonalizedProducts = (): Promise<GetPersonalizedProductsResponse> => {
  return apiService.get<GetPersonalizedProductsResponse>("/general/personalized-products");
};